import React from "react";
import styles from "./footer.module.css";
import { NavLink, useLocation } from "react-router-dom";

function Footer() {
  const location = useLocation();

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      window.scrollTo({
        top: section.offsetTop,
        behavior: "smooth",
      });
    }
  };
  const supportLink = () => {
    const supportSection = document.getElementById("support");
    if (supportSection) {
      window.scrollTo({
        top: supportSection.offsetTop,
        behavior: "smooth",
      });
    }
  };

  const handleSupportClick = (e) => {
    if (location.pathname !== "/") {
      e.preventDefault();
      window.location.href = "/#support";
    } else {
      scrollToSection("support");
    }
  };

  const handleContactClick = (e) => {
    if (location.pathname !== "/") {
      e.preventDefault();
      window.location.href = "/#partner";
    } else {
      scrollToSection("partner");
    }
  };

  return (
    <footer className={styles.footer_wrapper}>
      <div className={styles.footer_container}>
        <p>
          &copy; Copyright{" "}
          <span className={styles.footerLogo}>Business Corners</span>
        </p>
        <nav>
          <ul>
            <li>
              <NavLink
                className={styles.footerNavbarA}
                onClick={handleSupportClick}>
                {" "}
                Support{" "}
              </NavLink>
            </li>
            <li>
              <NavLink
                className={styles.footerNavbarA}
                onClick={handleContactClick}>
                {" "}
                Contact{" "}
              </NavLink>
            </li>
            <li>
              <NavLink to="/privacy-policy" className={styles.footerNavbarA}>
                {" "}
                Privacy Policy{" "}
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
